<template>
  <footer class="site-footer">
    <img class="brand" :src="logoSrc" :alt="t('brand')" width="165" height="22">
    <span>{{ t('footer.tagline') }}</span>
    <span>{{ t('footer.copy') }}</span>
  </footer>
</template>

<script setup>
import { useLocale } from '../composables/useLocale'

const { t } = useLocale()
const logoSrc = `${process.env.BASE_URL}logo/maalouf-logo.svg`
</script>

<style scoped>
.site-footer {
  width: 100%;
  max-width: var(--container);
  margin-inline: auto;
  /* Extra bottom space keeps the floating WhatsApp button off the last line. */
  padding: 48px var(--gutter) calc(40px + 56px + env(safe-area-inset-bottom, 0px));
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  font-size: 14px;
  color: var(--tertiary);
}

.brand {
  display: block;
  height: 22px;
  width: auto;
}
</style>
